import {getDateTime} from "../../../utils/public"
import{Toast} from "vant"

export function ruleTime (value, index, name, questionObj) {
  if (name == "startTime") {
    // 开始时间
    if (
      questionObj.endTime &&
      getDateTime(value) > getDateTime(questionObj.endTime)
    ){
      Toast.fail("开始时间必须小于结束时间");
      return false
    }
  }else {
    // 结束时间
    if (
      questionObj.startTime &&
      getDateTime(value) < getDateTime(questionObj.startTime)
    ) {
      Toast.fail("开始时间必须小于结束时间");
      return false
    }
  }
  return true
}